/**
 * Helper function for locking/unlocking body via css class
 * @param {Boolean} bool - boolean to lock(true) or unlock(false)
 * @param {Number} [positionY = 0] - Y-postion to scroll back
 * @param {Number} [positionX = 0] - X-postion to scroll back
 */
export default function lockBodyScroll(bool, positionY = 0, positionX = 0) {
  if (bool) {
    document.body.classList.add('locked');
  } else {
    document.body.classList.remove('locked');
    window.scrollTo(positionX, positionY);
  }
}
